import { FC, ReactNode } from 'react';
import { PageMetaSeo } from '@/components/page-seo-meta';

interface ISeoWrapperProps {
  seoMetaData?: object;
  currentUrlBase?: string;
  children: ReactNode;
}

const SeoWrapper: FC<ISeoWrapperProps> = ({ seoMetaData, currentUrlBase, children }) => (
  <>
    <PageMetaSeo currentUrlBase={currentUrlBase} seoMetaData={seoMetaData} />
    {children}
  </>
);

export default SeoWrapper;
